import Config from '../../config/config'

export default {
  install(editor) {
    const eventsAndListeners = Config.eventsAndListeners
    const allowedEventsList = Object.keys(editor.events)
    eventsAndListeners.forEach(item => {
      if (allowedEventsList.indexOf(item.event) > -1) {
        editor.on(item.event, item.listener)
      } else {
        throw new Error("Invalid event provided in 'eventsAndListeners' property in config.js.");
      }
    })
  }
}